import JSHelp from './JSHelp';
import CSSHelp from './CSSHelp';

export default { JSHelp, CSSHelp };
